var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "BjDrawerForm",
        {
          ref: "BjDrawerForm",
          attrs: {
            form: _vm.form,
            rules: _vm.rules,
            confirmDis: !_vm.hasChecklistFile || !_vm.canUpload,
            "wrapper-closable": true,
            "destroy-on-close": true,
            "label-width": "120px",
            width: "500px",
          },
          on: { handleConfirm: _vm.handleConfirm },
        },
        [
          _c("BjDivider", [_vm._v(_vm._s(_vm.$t("CustomerFunction.step5")))]),
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "UploadFile",
                {
                  ref: "UploadFileRef",
                  staticClass: "avatar-uploader",
                  attrs: {
                    limit: 20,
                    "limit-size": 5 * 1024,
                    accept: ".word, .excel, .pdf",
                    multiple: "",
                    concurrent: "",
                    "auto-upload": "",
                    "limit-hide": "",
                  },
                  on: { handleFileListChange: _vm.fileChange },
                },
                [
                  _c(
                    "template",
                    { slot: "default" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled: !_vm.canUpload,
                            size: "small",
                            type: "primary",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("BusinessImportHistory.page.SelectFile")
                            )
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
              _c(
                "div",
                { staticClass: "profit-fileRight" },
                [
                  _vm.hasChecklistFile
                    ? _vm._l(
                        _vm.form.checklistFileList,
                        function (file, index) {
                          return _c(
                            "div",
                            {
                              key: file.url + "_" + index,
                              staticClass: "file",
                              staticStyle: {
                                "line-height": "1.5",
                                "font-weight": "500",
                                "font-size": "14px",
                              },
                            },
                            [
                              _c("div", { staticClass: "fileUpload" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "flex-align flex-spacebetween",
                                    staticStyle: {
                                      color: "#3173d0",
                                      cursor: "pointer",
                                    },
                                  },
                                  [
                                    _c("div", { staticClass: "flex" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "ellipsis",
                                          staticStyle: { width: "190px" },
                                        },
                                        [
                                          _c(
                                            "el-tooltip",
                                            {
                                              staticClass: "item",
                                              attrs: {
                                                effect: "dark",
                                                content: file.name,
                                                placement: "top",
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "mr20" },
                                                [_vm._v(_vm._s(file.name))]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex-align flex-spacebetween",
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            staticClass: "edit-btn",
                                            staticStyle: {
                                              "font-size": "12px",
                                              "margin-right": "10px",
                                            },
                                            attrs: { size: "mini" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.downloadImageUrl(
                                                  file.url,
                                                  file.name
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("downloadText"))
                                            ),
                                            _c("i", {
                                              staticClass:
                                                "el-icon-download el-icon--right",
                                            }),
                                          ]
                                        ),
                                        _c(
                                          "el-button",
                                          {
                                            staticClass: "delete-btn",
                                            staticStyle: {
                                              "font-size": "12px",
                                              "margin-right": "10px",
                                            },
                                            attrs: {
                                              disabled: !_vm.canUpload,
                                              size: "mini",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.delFile(index)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(_vm._s(_vm.$t("delText"))),
                                            _c("i", {
                                              staticClass:
                                                "el-icon-delete red el-icon--right",
                                            }),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          )
                        }
                      )
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }